/* Phonics is isolated from the established Life Skills funnel. Real cart lines
   remain authoritative; a removal never rebuilds the remaining selection. */
(() => {
  const source = document.getElementById('dm-phonics-config');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const copy = config.copy || {};
  const products = config.products.filter(p => p.id && p.available);
  // Life Skills extras ship on by default in the Phonics batch as well (AOV).
  const crossExtras = [67596074647720, 67596074516648, 67596074483880, 67596074582184];
  const stateKey = 'dm-phonics-choice-v1';
  const root = () => window.Shopify?.routes?.root || '/';
  const original = window.PeppoBundle;
  let busy = false, scheduled = false;
  const readOptOut = () => { try { return new Set(JSON.parse(sessionStorage.getItem(stateKey) || '[]')); } catch (_) { return new Set(); } };
  const recordRemoval = id => { const choices = readOptOut(); choices.add(id); try { sessionStorage.setItem(stateKey, JSON.stringify([...choices])); } catch (_) {} };
  const escape = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const lines = drawer => [...drawer.querySelectorAll('.ocu-cart-line-item-wrapper')];
  const findLine = (drawer, product) => lines(drawer).find(line =>
    [...line.querySelectorAll('a[href]')].some(a => new URL(a.href, location.origin).pathname.endsWith('/products/' + product.handle)) ||
    line.querySelector('img')?.alt === product.title
  );
  const ownsCart = drawer => Boolean(findLine(drawer, {handle:config.mainHandle, title:'Phonics Workbook for Kids (FREE TODAY)'}));
  async function json(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, {...options, signal:controller.signal, headers:{Accept:'application/json',...options.headers}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Cart update failed');
      return data;
    } finally { clearTimeout(timeout); }
  }
  const readCart = () => json(root() + 'cart.js', {cache:'no-store'});
  function syncHeaderCount() {
    const cart = window.Zipify?.Cart?.cart;
    if (!Number.isInteger(cart?.item_count) || !Array.isArray(cart.items)) return;
    const countLabel = document.querySelector('#cart-icon-bubble .cart-count-bubble .visually-hidden');
    const label = (cart.item_count === 1 ? copy.cartCountOne : copy.cartCountMany)?.replace('__count__', String(cart.item_count));
    if (countLabel && label && countLabel.textContent !== label) countLabel.textContent = label;
  }
  function configureOcuProductForms() {
    const selector = '[data-dm-bundle-form]';
    document.querySelectorAll('product-form form,[data-dm-sticky-atc] form').forEach(form => {
      if ([config.mainId,67596073795752].includes(Number(form.querySelector('[name="id"]')?.value))) form.setAttribute('data-dm-bundle-form', '');
      else form.removeAttribute('data-dm-bundle-form');
    });
    [window.Zipify?.Cart?.api, window.Zipify?.OCU?.api].filter(Boolean).forEach(api => {
      const existing = typeof api.excludeActionButton === 'string' ? api.excludeActionButton : '';
      if (!existing.split(',').map(part => part.trim()).includes(selector)) api.excludeActionButton = [existing, selector].filter(Boolean).join(', ');
    });
  }
  async function addProduct(id) {
    if (busy) return;
    busy = true;
    try {
      // Read current state to prevent duplicate lines after rapid repeated clicks.
      const before = await readCart();
      if (!before.items.some(item => Number(item.variant_id) === id)) {
        await json(root() + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1,properties:{_ocu_cart_upsell_id:'dm-phonics-'+id,_dm_bundle_addon:'true'}}]})});
      }
      const cart = await readCart();
      if (window.Zipify?.Cart) window.Zipify.Cart.cart = cart;
      window.dispatchEvent(new CustomEvent('ocu:cart:update',{detail:{cart}}));
      document.dispatchEvent(new CustomEvent('ocu:cart:update',{detail:{cart}}));
    } catch (_) {
      const status = document.querySelector('[data-dm-phonics-status]');
      if (status) status.textContent = 'Could not add this extra. Please try again.';
    } finally { busy = false; schedule(); }
  }
  window.PeppoBundle = {
    ...original,
    async renderCart({variantId, triggerElement}) {
      if (![config.mainId,67596073795752].includes(Number(variantId))) return false;
      const instance = window.Zipify?.Cart?.instance;
      if (!instance?.isLoaded || instance.unpublished || typeof instance.updateCart !== 'function' || typeof instance.openCart !== 'function') return false;
      try {
        await instance.updateCart();
        await instance.openCart({preventUpdate:true, triggerElement});
        schedule();
        return true;
      } catch (_) { return false; }
    },
    async prepareFormData(formData) {
      if (Number(formData.get('id')) !== config.mainId) return original.prepareFormData(formData);
      const cart = await original.snapshot();
      if (!cart) return false;
      let existing = new Set(cart.items.map(item => Number(item.variant_id)));
      // One kit per cart: switching from the Life Skills kit starts a fresh Phonics bundle.
      if (existing.has(67596073795752)) {
        try { await json(root() + 'cart/clear.js', {method:'POST'}); } catch (_) {}
        existing = new Set(); original.invalidate?.();
        try { sessionStorage.removeItem('dm-phonics-choice-v1'); } catch (_) {}
      }
      if (existing.has(config.mainId)) return false;
      const excluded = readOptOut();
      const add = products.filter(p => !existing.has(p.id) && !excluded.has(p.id) &&
        !(p.handle === 'phonics-solar-system-busy-book' && existing.has(67596232884392)))
        .map(p => p.id).concat(crossExtras.filter(id => !existing.has(id) && !excluded.has(id))).concat(existing.has(67596498075816) ? [] : [67596498075816]);
      if (!add.length) return false;
      for (const [key,value] of [...formData.entries()]) {
        if (['id','quantity','selling_plan'].includes(key) || key.startsWith('properties[')) {
          const field = key.startsWith('properties[') ? `items[0][properties]${key.slice(10)}` : `items[0][${key}]`;
          formData.append(field,value); formData.delete(key);
        }
      }
      if (!formData.has('items[0][quantity]')) formData.append('items[0][quantity]','1');
      add.forEach((id,index) => {
        const prefix = `items[${index+1}]`;
        formData.append(prefix+'[id]',String(id));
        formData.append(prefix+'[quantity]','1');
        formData.append(prefix+'[properties][_ocu_cart_upsell_id]','dm-phonics-'+id);
        formData.append(prefix+'[properties][_dm_bundle_addon]','true');
      });
      return true;
    }
  };
  function enhance() {
    scheduled = false;
    configureOcuProductForms();
    syncHeaderCount();
    const drawer = document.querySelector('.ocu-cart-drawer');
    if (!drawer) return;
    if (window.DMCartDesign?.ownsCart(drawer)) return;
    const active = ownsCart(drawer);
    drawer.classList.toggle('dm-cart-phonics',active);
    if (!active) {
      drawer.querySelectorAll('.dm-phonics-extras,.dm-phonics-strip,.dm-phonics-lifetime').forEach(el => el.remove());
      drawer.querySelectorAll('.dm-phonics-lifetime-native').forEach(el => el.classList.remove('dm-phonics-lifetime-native'));
      return;
    }
    const main = findLine(drawer,{handle:config.mainHandle,title:'Phonics Workbook for Kids (FREE TODAY)'});
    const footer = drawer.querySelector('.ocu-cart-footer');
    if (!main || !footer) return;
    let strip = drawer.querySelector('.dm-phonics-strip');
    if (!strip) {
      strip = document.createElement('div'); strip.className = 'dm-phonics-strip';
      strip.innerHTML = `<span class="dm-phonics-strip__spark" aria-hidden="true">✦</span><span><strong>${escape(copy.stripTitle)}</strong><small>${escape(copy.stripNote)}</small></span>`;
      main.after(strip);
    }
    const lifetime = products.find(p => p.handle === 'phonics-lifetime-updates');
    products.forEach(p => {
      const line = findLine(drawer,p);
      if (!line) return;
      line.classList.toggle('dm-phonics-lifetime-native',p === lifetime);
      const title = line.querySelector('.ocu-cart-line-item-product-title');
      if (title && p.benefit && !line.querySelector('.dm-phonics-line-benefit')) {
        const benefit = document.createElement('p');
        benefit.className = 'dm-phonics-line-benefit';
        benefit.textContent = p.benefit;
        title.after(benefit);
      }
    });
    let extras = drawer.querySelector('.dm-phonics-extras');
    if (!extras) { extras = document.createElement('div'); extras.className='dm-phonics-extras'; main.parentElement.append(extras); }
    const missing = products.filter(p => p !== lifetime && !findLine(drawer,p));
    const signature = missing.map(p => p.id).join(',');
    if (extras.dataset.signature !== signature) {
      extras.dataset.signature=signature;
      extras.innerHTML = (missing.length ? '<p class="dm-phonics-extras__label">Add back an optional extra</p>' : '') + missing.map(p =>
        `<div class="dm-phonics-extra"><img src="${escape(p.image)}" width="52" height="52" alt=""><span><strong>${escape(p.title)}</strong>${p.benefit ? `<span class="dm-phonics-extra__benefit">${escape(p.benefit)}</span>` : ''}<small>${escape(p.price)}</small></span><button type="button" data-dm-phonics-add="${p.id}" aria-label="Add ${escape(p.title)}">+</button></div>`).join('') + '<p data-dm-phonics-status role="status"></p>';
    }
    if (lifetime) {
      let pin = footer.querySelector('.dm-phonics-lifetime');
      if (!pin) {
        pin=document.createElement('div'); pin.className='dm-phonics-lifetime';
        pin.innerHTML=`<img src="${escape(lifetime.image)}" alt="" width="46" height="46"><span><strong>Lifetime updates</strong><small>${escape(lifetime.price)} · one-time add-on</small></span><button type="button" data-dm-phonics-lifetime aria-pressed="false" aria-label="Add lifetime updates">+</button>`;
        footer.prepend(pin);
      }
      const selected = Boolean(findLine(drawer,lifetime));
      const button=pin.querySelector('button');
      button.setAttribute('aria-pressed',String(selected));
      button.setAttribute('aria-label',`${selected?'Remove':'Add'} lifetime updates`);
      if (button.textContent !== (selected?'✓':'+')) button.textContent=selected?'✓':'+';
    }
    footer.querySelectorAll('a,button').forEach(el => { if (/^keep browsing$/i.test(el.textContent.trim())) el.classList.add('dm-cart-hide'); });
  }
  function schedule() { if (!scheduled) { scheduled=true; requestAnimationFrame(enhance); } }
  document.addEventListener('click', event => {
    const target=event.target;
    const remove=target.closest('.ocu-cart-line-item-remove');
    const drawer=remove?.closest('.ocu-cart-drawer');
    if (drawer && ownsCart(drawer)) {
      const line=remove.closest('.ocu-cart-line-item-wrapper');
      const product=products.find(p => findLine(drawer,p)===line);
      if (product) recordRemoval(product.id);
    }
    const add=target.closest('[data-dm-phonics-add]');
    if (add) { event.preventDefault(); addProduct(Number(add.dataset.dmPhonicsAdd)); }
    const pin=target.closest('[data-dm-phonics-lifetime]');
    if (pin) {
      event.preventDefault();
      const p=products.find(p => p.handle==='phonics-lifetime-updates');
      const current=findLine(pin.closest('.ocu-cart-drawer'),p);
      if (current) { recordRemoval(p.id); current.querySelector('.ocu-cart-line-item-remove')?.click(); }
      else addProduct(p.id);
    }
    const sticky=target.closest('[data-dm-phonics-atc]');
    if (sticky) {
      event.preventDefault();
      const form=document.querySelector('product-form form');
      if (form) form.requestSubmit();
    }
  },true);
  // The Life Skills sticky form uses the same atomic primary product handler.
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-dm-sticky-atc] form')) return;
    const form = document.querySelector('product-form form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.requestSubmit();
  },true);

  window.DMPhonics={ownsCart,qualifies:cart => cart.items.some(i=>Number(i.variant_id)===config.mainId) && !cart.items.some(i=>[config.mysteryId,67596073795752].includes(Number(i.variant_id)))};
  if (config.currentProductId===config.mainId) document.documentElement.classList.add('dm-is-phonics');
  configureOcuProductForms();
  window.addEventListener('ocu:cart:loaded', configureOcuProductForms);
  window.addEventListener('ocu:cart:updated', syncHeaderCount);
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
  schedule();
})();
